<template>
  <div
    class="wrapper-404"
    v-once
  >
    <div class="content-404">
      <div class="text">
        <strong>404</strong>
        <div>
          FIN DE LA ROUTE CETTE PAGE N'EXISTE PLUS !
        </div>
      </div>
      <div class="button-wrapper">
        <rent-button
          href="/"
          is-anchor
        >
          Revenir à l'accueil
        </rent-button>
      </div>
    </div>
  </div>
</template>
<script>
import RentButton from '../shared/RentButton'

export default {
  name: 'Layout404',
  components: {
    RentButton,
  },
}
</script>
<style lang="scss" scoped>

.wrapper-404 {
  align-items: center;
  background: url('../../../images/404-small.jpg') no-repeat;
  background-size: cover;
  color: white;
  display: flex;
  font-family: $f-helv;
  justify-content: center;
  min-height: 155px;

  @include font-size(17px);

  @include teq-breakpoint($medium) {
    @include font-size(61px);

    align-items: flex-end;
    background: url('../../../images/404-large.jpg') no-repeat;
    background-size: cover;
    min-height: 495px;
    padding: 0 0 50px;
  }
}

.content-404 {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
}

.text {
  align-items: center;
  display: flex;
  line-height: 1;
  margin: auto;
  max-width: 230px;

  @include teq-breakpoint($medium) {
    max-width: 846px;
  }
}

strong {
  @include font-size(80px);

  @include teq-breakpoint($medium) {
    @include font-size(275px);
  }
}
</style>
